import React from "react";
import { useGlobalContext } from "../contextProvider/ContextProvider";
import general from "../styles/General.module.scss";
import checkmark from "../images/green-checkmark.svg";

const Submitted = () => {
  const { successful, setSubmitted, setCurrentStep } = useGlobalContext();

  const checkData = () => {
    setSubmitted(false);
    setCurrentStep(1);
  };

  return (
    <div>
      {successful ? (
        <>
          <div style={{ display: "flex", gap: "25px", paddingTop: "100px" }}>
            <img
              src={checkmark}
              alt="Bestätigung"
              className={general.successfulSubmitImg}
            />
            <p className={general.subHeading} style={{ maxWidth: "700px" }}>
              Vielen Dank für Ihre Anfrage, wir haben Ihnen unser
              Richtpreisangebot per E-Mail zugestellt.
            </p>
          </div>
        </>
      ) : (
        <>
          <p
            className={general.subHeading}
            style={{ maxWidth: "700px", marginBottom: "25px" }}
          >
            Leider ist beim Übermitteln Ihrer Daten ein Fehler aufgetreten,
            bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut!
          </p>
          <button
            className={`${general.greenButton} ${general.marginCentered}`}
            onClick={() => checkData()}
          >
            Eingabe prüfen
          </button>
        </>
      )}
    </div>
  );
};

export default Submitted;
